import React from 'react';
import { useCart } from '../contexts/CartContext';
import { useLaunchParams } from '@telegram-apps/sdk-react';
import './scss/Header.scss'; // Подключаем стили
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const Header = () => {
  const { user, isLoading, reloadUser } = useUser();
  const launchParams = useLaunchParams();
  const _user = launchParams?.initData?.user;
  const navigate = useNavigate();
  const {
      cartItems
    } = useCart();
  return (
    <header className='main-header'>
      <div className="row user-profile g-2 align-items-center" style={{cursor: "pointer"}} onClick={() => {navigate("/profile")}}>
        <div className='col-auto'>
          <div className='avatar-rounds'>
            <img
              className="user-avatar"
              src={_user?.photoUrl || 'https://via.placeholder.com/38'}
              alt="User Avatar"
            />
          </div>
          
        </div>
        
        <div className='col-auto span-center'>
          <span className="hello-profile">Привет</span>
          <span className="user-name">{_user?.firstName || 'Пользователь'} 
            {user?.isGroup && (<span className='badge-group-small'>В группе</span>)}
          </span>
          
        </div>
      </div>
      {cartItems.length > 0 ? (<></>) : (
        <div className='row channel-profile align-items-center g-2'>
        <div className='col-auto span-center-reverse'>
          <span className="channel-url">@cargosng</span>
          <span className="channel-text">Telegram-канал</span>
        </div>
        <div className='col-auto'>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2185_616)">
            <circle cx="12" cy="12" r="12" fill="#FECA1F"/>
            <path d="M16.631 7.78406C16.631 7.78406 17.8452 7.31062 17.744 8.4604C17.7103 8.93384 17.4067 10.5909 17.1707 12.3832L16.3612 17.6925C16.3612 17.6925 16.2938 18.4702 15.6867 18.6055C15.0796 18.7408 14.169 18.1321 14.0003 17.9968C13.8654 17.8954 11.4709 16.3736 10.6277 15.6296C10.3916 15.4267 10.1218 15.0209 10.6614 14.5475L14.2027 11.1658C14.6074 10.76 15.0122 9.81309 13.3258 10.9629L8.60409 14.1755C8.60409 14.1755 8.06447 14.5137 7.05269 14.2093L4.86044 13.533C4.86044 13.533 4.051 13.0257 5.4338 12.5184C8.80647 10.929 12.9548 9.30581 16.631 7.78406Z" fill="#161618"/>
            </g>
            <defs>
            <clipPath id="clip0_2185_616">
            <rect width="24" height="24" fill="white"/>
            </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      )}
      
    </header>
    
  );
};

export default Header;
